import styled from "styled-components";

export const RegisterRadiologistContainer = styled.div`
  .back-btn {
    font-size: 14px;
    font-weight: 600;
    color: #666;
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 1px solid var(--blue);
    color: var(--blue);
    padding: 8px 12px;
    border-radius: 4px;
    svg {
      height: 20px;
      width: 20px;
    }
  }
  form {
    margin: 3em 0;
    @media (max-width: 650px) {
      margin: 2em 0;
    }
    h5 {
      color: var(--text-body-dark);
      font-weight: 600;
      font-size: 21px;
      line-height: 136.02%;
      margin-bottom: 1em;

      @media (max-width: 650px) {
        font-size: 1.125em;
      }
    }
    h4 {
      font-weight: 500;
      font-size: 21px;
      line-height: 136.02%;
      margin-bottom: 1em;
      margin-top: 2.5em;
      /* identical to box height, or 29px */

      /* Text/Heading/Dark */

      color: #27272e;
    }
    div.button {
      margin: 1.5em 0;

      .continue {
        background-color: var(--soft-blue);
        color: var(--blue) !important;
        margin-top: 1.5em;
      }
    }
  }

  .upload-group {
    width: 100%;
    margin: 1em 0;
  }

  div.file-upload {
    background: rgba(235, 242, 250, 1);
    width: 100%;
    height: 120px;
    margin-top: 8px;
    border-radius: 15px;
    border: 1px dashed #7895ff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    justify-content: center;
    padding: 0 1em;
    text-align: center;
    width: 100%;

    button {
      background-color: #f5f6f4;
      border: 1px solid #e4e6e6 !important;
      display: flex;
      align-items: center;
      padding: 1.2rem 1.6rem !important;
      border-radius: 8px;
      color: #777777;
      font-size: 15px;
      font-weight: 500;
    }

    &:hover {
      border-style: solid;
    }
    p {
      font-weight: 600;
      font-size: 16px;
      line-height: 25px;
      /* identical to box height, or 156% */

      /* Text/Body/Muted */

      color: #718096;
      margin-top: 8px;
    }
  }

  .file-name {
    display: inline-block;
    vertical-align: top;
    font-weight: 600;
    font-size: 16px;
    line-height: 25px;
    display: flex;
    align-items: center;
    color: #425466;
    margin-bottom: 0.6em;
  }

  .uploaded-doc {
    display: flex;
    align-items: flex-start;
    margin-right: 2rem;
    .file-remove {
      margin-left: -1.4rem;
      margin-top: 0;
      svg {
        height: 24px;
        width: 24px;
      }
    }
  }
`;
